import * as React from "react";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { useUserContext } from "../../../user-provider";
import { useUtilityContext } from "../../../utility-provider";
import { apiRequest, postPython } from "../../../api/ApiCall";
import { userLogging } from "../../../utility/firestore";
import {
    getFileMetadata,
    uploadFile,
    deleteUploadFile,
} from "../../../utility/storage";
import PdfViewer from "../../../utility/PdfViewer";
import PdfViewerModal from "../../../utility/PdfViewerModal";
import { handlePdfPreviewScreenOpen } from "../../../utility/PdfViewerModal";
import { setSaveStatus } from "../../../features/longPageSlice";
import {
    IconButton,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TextField,
    Typography,
    Box,
    Button,
    TableContainer,
    Grid,
} from "@mui/material";
import { LOCAL_CONSTANT } from "../../Const";
import MessageDialog from "../../components/MessageDialog";
import { DeleteConfirmationModal } from "../../ResearchReport/DeleteConfirmationModal";
import DeleteIcon from "@mui/icons-material/Delete";
import DownloadIcon from "@mui/icons-material/Download";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import {
    setAdditionalResearchCoverPdf,
    setAdditionalResearchCoverConfirmedPdf,
} from "../../../features/additionalResearchSlice";
import {
    staffName,
    commonFileDownload,
    getAccessToken,
    fileExtensionCheck,
} from "../../Common";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import DeficiencyCommentRegistModal from "../../components/DeficiencyCommentRegistModal";
import {
    additionalResearchStringTypeList,
    initAdditionalResearchCommentTextFieldObj,
} from "../../../data/type";
import { setPermissionFunc } from "../../components/PermissionFunc";
import {
    chatBubbleErrorSx,
    chatBubbleIconSx,
    iconHover,
} from "../../components/ChatBubbleAndEditIconStyle";
import { upsertLocationAddSurveyFileParam } from "../../components/LocationAddSurveyFunc";
import {
    setAddSurveyObj,
    setAddSurveyPageObj,
} from "../../../features/locationAddSurveySlice";
import CancellationAddSurveyModal from "./CancellationAddSurveyModal";

const headerCell = (type: string) => {
    return{
        backgroundColor: "#D9D9D9",
        fontSize: "12px",
        color: "black",
        borderBottom: "1px solid black",
        fontWeight: "Bold",
        width: type === 'FILE_NAME' ? '40%'
        : type === 'UPLOAD_DATE' ? '15%' 
        : type === 'UPLOADER' ? '15%' 
        : '6%',
        textAlign: type === 'OTHER' ? 'center' : 'start'
    }
};

//参照値算出結果のラベル
const labels = [
    { header: "初年度", Name: "reference_value_1" },
    { header: "2年度", Name: "reference_value_2" },
    { header: "3年度", Name: "reference_value_3" },
    { header: "4年度", Name: "reference_value_4" },
    { header: "5年度", Name: "reference_value_5" },
];

interface AddCoverProps {
    props: {
        menuLabel: string;
        correctionLabel: string;
        addButton: string;
        comenntButton: string;
    };
}

const AddCover: React.FC<AddCoverProps> = ({ props }) => {
    //候補地NOと枝を取得
    const objLongPageParam = useAppSelector((state) => state.longPage.param);
    //調査書基本を取得
    const objLocationBase = useAppSelector(
        (state) => state.longPage.locationBase
    );
    //追加調査を取得
    const objLocationAddSurvey = useAppSelector(
        (state) => state.locationAddSurvey.obj
    );
    //追加調査を取得
    const surveyPageObj = useAppSelector(
        (state) => state.locationAddSurvey.pageObj
    );
    //ロングページ保存用ステータス
    const objLongPageSaveStatus = useAppSelector(
        (state) => state.longPage.saveStatus
    );
    // 不備コメントリスト
    const listDeficiencyComment = useAppSelector(
        (state) => state.deficiencyComment
    );

    const dispatch = useAppDispatch();

    //ユーザIDを取得
    const [userId, setUserId] = useState<string>("");
    //ユーザー種別を取得
    const [userType, setUserType] = useState<string>("");
    const user = useUserContext();

    const utilityCtx = useUtilityContext();

    //ファイルアップロード
    const [message, setMessage] = useState<string>("");
    const [messageDialogOpen, setMessageDialogOpen] = useState<boolean>(false);
    const [hasButton, setHasButton] = useState<boolean>(false);

    //Excelアップロード情報
    const [coverExcelPath, setCoverExcelPath] = useState<any>({});
    const [coverPdfPath, setCoverPdfPath] = useState<any>({});
    const [coverConfirmExcelPath, setCoverConfirmExcelPath] = useState<any>({});
    const [coverConfirmPdfPath, setCoverConfirmPdfPath] = useState<any>({});

    //モーダル開閉フラグ(削除確認)
    const [deleteConfModalOpen, setDeleteConfModalOpen] = useState(false);
    const [path, setPath] = useState<string>("");
    const [pdfPath, setPdfPath] = useState<string>("");

    const [showCancellationModal, setShowCancellationModal] =
        React.useState<boolean>(false);

    const [approvalMgrStamp, setApprovalMgrStamp] = React.useState<string>("");
    const [approvalGmStamp, setApprovalGmStamp] = React.useState<string>("");
    const [approvalResearchMgrStamp, setApprovalResearchMgrStamp] =
        React.useState<string>("");
    const [approvalResearchGmStamp, setApprovalResearchGmStamp] =
        React.useState<string>("");
    const [approvalReferenceStaffStamp, setApprovalReferenceStaffStamp] =
        React.useState<string>("");
    const [
        approvalReferenceResearchMgrStamp,
        setApprovalReferenceResearchMgrStamp,
    ] = React.useState<string>("");
    const [
        approvalReferenceResearchGmStamp,
        setApprovalReferenceResearchGmStamp,
    ] = React.useState<string>("");

    //参照値算出結果のテキストフィールド
    const [addSurveyReferenceValue, setAddSurveyReferenceValue] = useState<any>(
        {
            reference_value_1: "",
            reference_value_2: "",
            reference_value_3: "",
            reference_value_4: "",
            reference_value_5: "",
        }
    );

    //不備コメントモーダル内、TextFiledのコメント
    const [
        additionalResearchCommentTextFiledObj,
        setAdditionalResearchCommentTextFiledObj,
    ] = useState<additionalResearchStringTypeList>(
        initAdditionalResearchCommentTextFieldObj
    );
    //不備コメントモーダルラベル名
    const [labelNameStr, setLabelNameStr] = useState<string>("");
    //不備コメントモーダル開閉フラグ
    const [deficiencyComentModalFlag, setDeficiencyComentModalFlag] =
        useState(false);

    //プレビュー
    const previewPdfPath = useAppSelector(
        (state) => state.additionalResearch.coverPdfPath
    );
    const previewConfirmedPdfPath = useAppSelector(
        (state) => state.additionalResearch.coverConfirmedPdfPath
    );

    const [pdfPreviewModalFlag, setPdfPreviewModalFlag] =
        useState(false);

    const handleValueChange = (path: any, labelName: string) => {
        if (
            previewPdfPath === path?.fullPath ||
            previewConfirmedPdfPath === path?.fullPath
        ) {
            if (props.menuLabel === LOCAL_CONSTANT.LABEL.COVER_REFERENCE) {
                dispatch(setAdditionalResearchCoverPdf(""));
            } else if (
                props.menuLabel === LOCAL_CONSTANT.LABEL.COVER_CONFIRMED
            ) {
                dispatch(setAdditionalResearchCoverConfirmedPdf(""));
            }
        } else {
            if (props.menuLabel === LOCAL_CONSTANT.LABEL.COVER_REFERENCE) {
                dispatch(setAdditionalResearchCoverPdf(path.fullPath));
            } else if (
                props.menuLabel === LOCAL_CONSTANT.LABEL.COVER_CONFIRMED
            ) {
                dispatch(setAdditionalResearchCoverConfirmedPdf(path.fullPath));
            }
        }
    };

    //インプット 参照値算出結果
    const handleIntInputChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        labelName: string
    ) => {
        const targetValue = e.target.value;
        if (/^$|^0$|^[1-9]\d*$/.test(targetValue)) {
            //空文字列、0、または正の整数のみ可能
            setAddSurveyReferenceValue({
                ...addSurveyReferenceValue,
                [labelName]: e.target.value,
            });
        }
        //更新フラグ
        if (!objLongPageSaveStatus.AddSurvey)
            dispatch(
                setSaveStatus({ ...objLongPageSaveStatus, AddSurvey: true })
            );
    };

    //参照値算出結果をReduxへ保存
    const handleInputBlur = (
        e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement, Element>,
        labelName: string
    ) => {
        dispatch(
            setAddSurveyObj({
                ...objLocationAddSurvey,
                [labelName]: e.target.value,
            })
        );
    };

    const handleModalOpen = (pathParam: string, pdfPathParam: string) => {
        setDeleteConfModalOpen(true);
        setPath(pathParam);
        setPdfPath(pdfPathParam);
    };

    const handlePdfPreviewModalOpen = (pdfPathParam: string) => {
        setPdfPreviewModalFlag(true);
        setPdfPath(pdfPathParam);
    };

    const closeMessageDialog = () => {
        setMessage("");
        setHasButton(false);
        setMessageDialogOpen(false);
    };

    const handleClickFile = (mode: string) => {
        let fileElem = document.getElementById("addCoverFileElem");
        if (props.menuLabel === LOCAL_CONSTANT.LABEL.COVER_CONFIRMED) {
            fileElem = document.getElementById("addCoverConfirmedFileElem");
        }
        let tmpFileName = "";
        let fileName = "";
        let pdfFileName = "";
        if (mode === LOCAL_CONSTANT.LABEL.COVER_REFERENCE) {
            // プレビュー削除
            dispatch(setAdditionalResearchCoverPdf(""));
            tmpFileName =
                objLongPageParam.planAreaId + "_TMP_追加調査参考値表紙.xlsx";
            fileName = objLongPageParam.planAreaId + "_追加調査参考値表紙.xlsx";
            pdfFileName =
                objLongPageParam.planAreaId + "_追加調査参考値表紙.pdf";
            dispatch(
                setAddSurveyPageObj({
                    ...surveyPageObj,
                    reference_menuLabel: props.menuLabel,
                    reference_correctionLabel: props.correctionLabel,
                    reference_addButton: props.addButton,
                    reference_comenntButton: props.comenntButton,
                    reference_tmp_fileName: tmpFileName,
                    reference_fileName: fileName,
                    reference_pdfFileName: pdfFileName,
                })
            );
        } else if (mode === LOCAL_CONSTANT.LABEL.COVER_CONFIRMED) {
            // プレビュー削除
            dispatch(setAdditionalResearchCoverConfirmedPdf(""));
            tmpFileName =
                objLongPageParam.planAreaId +
                "_TMP_追加調査参考値確定表紙.xlsx";
            fileName =
                objLongPageParam.planAreaId + "_追加調査参考値確定表紙.xlsx";
            pdfFileName =
                objLongPageParam.planAreaId + "_追加調査参考値確定表紙.pdf";
            dispatch(
                setAddSurveyPageObj({
                    ...surveyPageObj,
                    confirmed_menuLabel: props.menuLabel,
                    confirmed_correctionLabel: props.correctionLabel,
                    confirmed_addButton: props.addButton,
                    confirmed_comenntButton: props.comenntButton,
                    confirmed_tmp_fileName: tmpFileName,
                    confirmed_fileName: fileName,
                    confirmed_pdfFileName: pdfFileName,
                })
            );
        }

        if (fileElem) {
            fileElem.click();
        }
    };

    // ファイル拡張子をチェックし、問題なければアップロード処理を実行
    const handleChangeFile = (newFile: any) => {
        // ファイル拡張子チェック（.xlsxのみ許可）
        if (
            fileExtensionCheck(
                newFile.target.files[0],
                LOCAL_CONSTANT.FILE_EXTENSIONS.EXCEL,
                setMessageDialogOpen,
                setMessage,
                setHasButton,
                LOCAL_CONSTANT.CONFIRM_MESSAGE.EXTENSION_CHECK_EXCEL
            )
        ) {
            // 拡張子チェックOKの場合、ファイルアップロード処理を実行
            fileUpload(newFile.target.files[0]);
        }
        // ファイル選択をリセット
        newFile.target.value = "";
    };

    //ファイル保存
    const fileDownload = (data: any) => {
        commonFileDownload("/" + data.fullPath, data.name);
    };

    //ファイルアップロード
    const fileUpload = (file: any) => {
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        (async () => {
            try {
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.UPLOAD_FILE);
                setMessageDialogOpen(true);
                const excel_route =
                    objLongPageParam.planAreaId +
                    "/" +
                    objLongPageParam.branch +
                    "/excel/";
                const pdf_route =
                    objLongPageParam.planAreaId +
                    "/" +
                    objLongPageParam.branch +
                    "/pdf/";

                let tmp_file_name = "";
                let file_name = "";
                let pdf_file_name = "";
                if (props.menuLabel === LOCAL_CONSTANT.LABEL.COVER_REFERENCE) {
                    tmp_file_name = surveyPageObj.reference_tmp_fileName;
                    file_name = surveyPageObj.reference_fileName;
                    pdf_file_name = surveyPageObj.reference_pdfFileName;
                } else if (
                    props.menuLabel === LOCAL_CONSTANT.LABEL.COVER_CONFIRMED
                ) {
                    tmp_file_name = surveyPageObj.confirmed_tmp_fileName;
                    file_name = surveyPageObj.confirmed_fileName;
                    pdf_file_name = surveyPageObj.confirmed_pdfFileName;
                }

                await uploadFile(file, excel_route + tmp_file_name);
                const uploadFilePath = "/excel/" + file_name;
                const pdfFileName = "/pdf/" + pdf_file_name;
                // python
                const pythonResult = await postPython({
                    mode: "regist",
                    endPoint: "/excel-add-print-pdf",
                    query: {
                        plan_area_id: objLongPageParam.planAreaId,
                        branch: objLongPageParam.branch,
                        tmp_file_name: tmp_file_name,
                        file_name: file_name,
                        pdf_file_name: pdf_file_name,
                        task_id: "",
                        mode: "upload",
                    },
                });
                if (pythonResult.data.data.result === "") {
                    setMessage(
                        LOCAL_CONSTANT.CONFIRM_MESSAGE
                            .NO_CREATE_PDF_APPROVAL_SURVEY
                    );
                    setHasButton(true);
                    if (utilityCtx.hideSpinner) {
                        utilityCtx.hideSpinner();
                    }
                } else {
                    const uploadResultPdfFile = await getFileMetadata(
                        "/" + pdf_route + pdf_file_name
                    );
                    if (
                        props.menuLabel === LOCAL_CONSTANT.LABEL.COVER_REFERENCE
                    ) {
                        setCoverPdfPath(uploadResultPdfFile);
                    } else if (
                        props.menuLabel === LOCAL_CONSTANT.LABEL.COVER_CONFIRMED
                    ) {
                        setCoverConfirmPdfPath(uploadResultPdfFile);
                    }
                    //DB保存
                    let column = "cover_excel_path";
                    if (
                        props.menuLabel === LOCAL_CONSTANT.LABEL.COVER_CONFIRMED
                    ) {
                        column = "cover_confirm_excel_path";
                    }
                    const params = upsertLocationAddSurveyFileParam({
                        objLocationAddSurvey: objLocationAddSurvey,
                        plan_area_id: objLongPageParam.planAreaId,
                        branch: objLongPageParam.branch,
                        uploadFile: uploadFilePath,
                        pdfFileName: pdfFileName,
                        column: column,
                        user_id: userId,
                        fileName: file_name,
                        status: "upload",
                    });

                    await updateRegist(
                        params,
                        LOCAL_CONSTANT.FUNCTION_NAME.COVER_FILE_UPLOAD
                    );
                    //Redux保存
                    if (
                        props.menuLabel === LOCAL_CONSTANT.LABEL.COVER_REFERENCE
                    ) {
                        dispatch(
                            setAddSurveyObj({
                                ...objLocationAddSurvey,
                                cover_excel_path: uploadFilePath,
                                cover_excel_user: userId,
                                cover_pdf_path: pdfFileName,
                                cover_pdf_user: userId,
                            })
                        );
                    } else if (
                        props.menuLabel === LOCAL_CONSTANT.LABEL.COVER_CONFIRMED
                    ) {
                        dispatch(
                            setAddSurveyObj({
                                ...objLocationAddSurvey,
                                cover_confirm_excel_path: uploadFilePath,
                                cover_confirm_excel_user: userId,
                                cover_confirm_pdf_path: pdfFileName,
                                cover_confirm_pdf_user: userId,
                            })
                        );
                    }

                    setMessage(
                        LOCAL_CONSTANT.CONFIRM_MESSAGE.SUCCESS_UPLOAD_FILE
                    );
                    setHasButton(true);
                    if (utilityCtx.hideSpinner) {
                        utilityCtx.hideSpinner();
                    }
                }
            } catch (e) {
                console.log(e);
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.ERROR_UPLOAD_FILE);
                setHasButton(true);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            }
        })();
    };

    //ファイル削除
    const handleExcelDeleteChange = () => {
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        (async () => {
            try {
                // プレビュー閉じる
                dispatch(setAdditionalResearchCoverPdf(""));
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.DELETE_FILE);
                setMessageDialogOpen(true);
                //CloudStorageから削除対象のExcelファイル情報を取得
                const deleteFile = await getFileMetadata(path);
                //DB保存
                let column = "";
                if (props.menuLabel === LOCAL_CONSTANT.LABEL.COVER_REFERENCE) {
                    column = "cover_excel_delete";
                } else if (
                    props.menuLabel === LOCAL_CONSTANT.LABEL.COVER_CONFIRMED
                ) {
                    column = "cover_confirm_excel_delete";
                }

                const params = upsertLocationAddSurveyFileParam({
                    objLocationAddSurvey: objLocationAddSurvey,
                    plan_area_id: objLongPageParam.planAreaId,
                    branch: objLongPageParam.branch,
                    uploadFile: deleteFile,
                    pdfFileName: "",
                    column: column,
                    user_id: userId,
                    fileName: "表紙",
                    status: column,
                });
                await updateRegist(
                    params,
                    LOCAL_CONSTANT.FUNCTION_NAME.COVER_FILE_DELETE
                );
                // ファイル削除
                await deleteUploadFile(deleteFile, path);
                const deletePdfFile = await getFileMetadata(pdfPath);
                await deleteUploadFile(deletePdfFile, pdfPath);
                //Redux保存
                if (props.menuLabel === LOCAL_CONSTANT.LABEL.COVER_REFERENCE) {
                    dispatch(
                        setAddSurveyObj({
                            ...objLocationAddSurvey,
                            cover_excel_path: "",
                            cover_excel_user: "",
                            cover_pdf_path: "",
                            cover_pdf_user: "",
                        })
                    );
                } else if (
                    props.menuLabel === LOCAL_CONSTANT.LABEL.COVER_CONFIRMED
                ) {
                    dispatch(
                        setAddSurveyObj({
                            ...objLocationAddSurvey,
                            cover_confirm_excel_path: "",
                            cover_confirm_excel_user: "",
                            cover_confirm_pdf_path: "",
                            cover_confirm_pdf_user: "",
                        })
                    );
                }

                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.SUCCESS_DELETE_FILE);
                setHasButton(true);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            } catch (e) {
                console.log(e);
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.ERROR_DELETE_FILE);
                setHasButton(true);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            }
        })();
    };

    const updateRegist = (params: any, function_name: string) => {
        userLogging(function_name, params, user);
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        (async () => {
            try {
                await apiRequest(params);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            } catch (e) {
                console.log(e);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            }
        })();
    };

    // 吹き出しをクリックしたとき、モーダル画面を開く
    const handleChatBubbleClick = (labelName: string) => {
        setLabelNameStr(labelName);
        setDeficiencyComentModalFlag(true);
        setAdditionalResearchCommentTextFiledObj({
            ...additionalResearchCommentTextFiledObj,
            [labelName]: "",
        }); //テキストフィールドのコメントを初期化
    };

    // モーダル内でのコメント取得
    const handleCommentChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        labelName: string
    ) => {
        setAdditionalResearchCommentTextFiledObj({
            ...additionalResearchCommentTextFiledObj,
            [labelName]: e.target.value,
        });
    };

    // モーダル内の保存ボタンをクリックしたとき不備コメントを保存
    const handleSaveComment = async (labelName: string) => {
        //不備コメントを登録
        const params = {
            mode: "regist",
            endPoint: "/location/Deficiency/v1/regist",
            query: {
                plan_area_id: objLongPageParam.planAreaId,
                branch: objLongPageParam.branch,
                status_seq: objLocationBase.status_seq,
                table_name: LOCAL_CONSTANT.TABLE.BASE,
                column_name: labelName,
                comment: additionalResearchCommentTextFiledObj[labelName],
                sub_key: LOCAL_CONSTANT.DEFICIENCY.DEFAULT_SUB_KEY,
            },
        };
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        try {
            await apiRequest(params);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
            //モーダルを閉じる
            setDeficiencyComentModalFlag(false);
        } catch (e) {
            console.log(e);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
            //モーダルを閉じる
            setDeficiencyComentModalFlag(false);
        }
    };

    useEffect(() => {
        //ReduxをuseStateに保存
        setAddSurveyReferenceValue({
            ...objLocationAddSurvey,
            reference_value_1: objLocationAddSurvey.reference_value_1,
            reference_value_2: objLocationAddSurvey.reference_value_2,
            reference_value_3: objLocationAddSurvey.reference_value_3,
            reference_value_4: objLocationAddSurvey.reference_value_4,
            reference_value_5: objLocationAddSurvey.reference_value_5,
        });
        const bucket_path =
            process.env.REACT_APP_GOOGLE_STORAGE +
            "/" +
            process.env.REACT_APP_FIREBASE_STORAGE_BUCKET +
            "/" +
            objLongPageParam.planAreaId +
            "/" +
            objLongPageParam.branch;
        const access_token = getAccessToken();
        if (objLocationAddSurvey.approval_research_mgr_stamp !== "") {
            setApprovalResearchMgrStamp(
                bucket_path +
                    objLocationAddSurvey.approval_research_mgr_stamp +
                    access_token
            );
        } else {
            setApprovalResearchMgrStamp("");
        }
        if (objLocationAddSurvey.approval_research_gm_stamp !== "") {
            setApprovalResearchGmStamp(
                bucket_path +
                    objLocationAddSurvey.approval_research_gm_stamp +
                    access_token
            );
        } else {
            setApprovalResearchGmStamp("");
        }
        if (objLocationAddSurvey.approval_mgr_stamp !== "") {
            setApprovalMgrStamp(
                bucket_path +
                    objLocationAddSurvey.approval_mgr_stamp +
                    access_token
            );
        } else {
            setApprovalMgrStamp("");
        }
        if (objLocationAddSurvey.approval_gm_stamp !== "") {
            setApprovalGmStamp(
                bucket_path +
                    objLocationAddSurvey.approval_gm_stamp +
                    access_token
            );
        } else {
            setApprovalGmStamp("");
        }
        if (objLocationAddSurvey.approval_reference_staff_stamp !== "") {
            setApprovalReferenceStaffStamp(
                bucket_path +
                    objLocationAddSurvey.approval_reference_staff_stamp +
                    access_token
            );
        } else {
            setApprovalReferenceStaffStamp("");
        }
        if (objLocationAddSurvey.approval_reference_research_mgr_stamp !== "") {
            setApprovalReferenceResearchMgrStamp(
                bucket_path +
                    objLocationAddSurvey.approval_reference_research_mgr_stamp +
                    access_token
            );
        } else {
            setApprovalReferenceResearchMgrStamp("");
        }
        if (objLocationAddSurvey.approval_reference_research_gm_stamp !== "") {
            setApprovalReferenceResearchGmStamp(
                bucket_path +
                    objLocationAddSurvey.approval_reference_research_gm_stamp +
                    access_token
            );
        } else {
            setApprovalReferenceResearchGmStamp("");
        }
    }, [objLocationAddSurvey, objLongPageParam]);

    //表紙ボタンしたにあるExcel情報を取得
    useEffect(() => {
        (async () => {
            if (utilityCtx.showSpinner) {
                utilityCtx.showSpinner();
            }
            try {
                const route =
                    "/" +
                    objLongPageParam.planAreaId +
                    "/" +
                    objLongPageParam.branch;
                if (props.menuLabel === LOCAL_CONSTANT.LABEL.COVER_REFERENCE) {
                    if (objLocationAddSurvey.cover_excel_path) {
                        const uploadResultFile = await getFileMetadata(
                            route + objLocationAddSurvey.cover_excel_path
                        );
                        setCoverExcelPath(uploadResultFile);
                    }
                    if (objLocationAddSurvey.cover_pdf_path) {
                        const resultFile = await getFileMetadata(
                            route + objLocationAddSurvey.cover_pdf_path
                        );
                        setCoverPdfPath(resultFile);
                    }
                }
                if (props.menuLabel === LOCAL_CONSTANT.LABEL.COVER_CONFIRMED) {
                    if (objLocationAddSurvey.cover_confirm_excel_path) {
                        const uploadResultFile = await getFileMetadata(
                            route +
                                objLocationAddSurvey.cover_confirm_excel_path
                        );
                        setCoverConfirmExcelPath(uploadResultFile);
                    }
                    if (objLocationAddSurvey.cover_confirm_pdf_path) {
                        const resultFile = await getFileMetadata(
                            route + objLocationAddSurvey.cover_confirm_pdf_path
                        );
                        setCoverConfirmPdfPath(resultFile);
                    }
                }

                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            } catch (e) {
                console.log(e);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            }
        })();
    }, [
        objLocationAddSurvey.cover_excel_user,
        objLocationAddSurvey.cover_confirm_excel_path,
        objLocationAddSurvey.cover_confirm_pdf_path,
        objLocationAddSurvey.cover_excel_path,
        objLocationAddSurvey.cover_pdf_path,
        objLongPageParam.branch,
        objLongPageParam.planAreaId,
        surveyPageObj.confirmed_menuLabel,
    ]); //追加調査_表紙_excel_ユーザーIDで制御

    useEffect(() => {
        if (JSON.parse(user.userData || "null") !== null) {
            //ユーザーIDを取得
            setUserId(JSON.parse(user.userData || "null").staff_number);
            //ユーザー種別を取得
            setUserType(JSON.parse(user.userData || "null").user_type);
        }
    }, [user]);

    const handleCancellation = (mode: string) => {
        setShowCancellationModal(true);
    };

    // ファイルアップロード権限
    const hasDisabled = () => {
        let disabled = true;
        if (props.menuLabel === LOCAL_CONSTANT.LABEL.COVER_REFERENCE) {
            disabled = setPermissionFunc(
                userType,
                objLocationBase.task_id,
                LOCAL_CONSTANT.NAVI.ADDITIONAL_RESEARCH,
                props.addButton
            );
            if (userType === LOCAL_CONSTANT.USER_TYPE.RR) {
                if (
                    objLocationAddSurvey.approval_reference_research_mgr_flag ===
                    "1"
                ) {
                    disabled = true;
                }
            } else if (userType === LOCAL_CONSTANT.USER_TYPE.RFC) {
                if (objLocationAddSurvey.approval_reference_rm_flag === "1") {
                    disabled = true;
                }
            }
        } else if (props.menuLabel === LOCAL_CONSTANT.LABEL.COVER_CONFIRMED) {
            disabled = setPermissionFunc(
                userType,
                objLocationBase.task_id,
                LOCAL_CONSTANT.NAVI.ADDITIONAL_RESEARCH,
                props.comenntButton
            );
            if (userType === LOCAL_CONSTANT.USER_TYPE.RR) {
                if (objLocationAddSurvey.approval_research_mgr_flag === "1") {
                    disabled = true;
                }
            } else if (userType === LOCAL_CONSTANT.USER_TYPE.RFC) {
                if (
                    objLocationAddSurvey.approval_mgr_flag === "1" ||
                    objLocationAddSurvey.approval_reference_staff_flag !==
                        "1" ||
                    objLocationAddSurvey.approval_reference_research_mgr_flag !==
                        "1" ||
                    objLocationAddSurvey.approval_reference_rm_flag !== "1"
                ) {
                    disabled = true;
                }
            }
        }

        return disabled;
    };

    // ファイル削除権限
    const hasDeleteDisabled = () => {
        let disabled = setPermissionFunc(userType, objLocationBase.task_id, LOCAL_CONSTANT.NAVI.ADDITIONAL_RESEARCH, 'deleteButton');
        if (props.menuLabel === LOCAL_CONSTANT.LABEL.COVER_REFERENCE) {
            if (userType === LOCAL_CONSTANT.USER_TYPE.RR) {
                if (
                    objLocationAddSurvey.approval_reference_research_mgr_flag ===
                    "1"
                ) {
                    disabled = true;
                }
            } else if (userType === LOCAL_CONSTANT.USER_TYPE.RFC) {
                if (objLocationAddSurvey.approval_reference_rm_flag === "1") {
                    disabled = true;
                }
            }
        } else if (props.menuLabel === LOCAL_CONSTANT.LABEL.COVER_CONFIRMED) {
            if (userType === LOCAL_CONSTANT.USER_TYPE.RR) {
                if (objLocationAddSurvey.approval_research_mgr_flag === "1") {
                    disabled = true;
                }
            } else if (userType === LOCAL_CONSTANT.USER_TYPE.RFC) {
                if (objLocationAddSurvey.approval_mgr_flag === "1") {
                    disabled = true;
                }
            }
        }

        return disabled;
    };

    // 承認済み表示
    const displayApproved = () => {
        let display = "none";
        if (props.menuLabel === LOCAL_CONSTANT.LABEL.COVER_REFERENCE) {
            if (userType === LOCAL_CONSTANT.USER_TYPE.RR) {
                if (
                    objLocationAddSurvey.approval_reference_research_mgr_flag ===
                    "1"
                ) {
                    display = "block";
                }
            } else if (userType === LOCAL_CONSTANT.USER_TYPE.RFC) {
                if (objLocationAddSurvey.approval_reference_rm_flag === "1") {
                    display = "block";
                }
            }
        } else if (props.menuLabel === LOCAL_CONSTANT.LABEL.COVER_CONFIRMED) {
            if (userType === LOCAL_CONSTANT.USER_TYPE.RR) {
                if (objLocationAddSurvey.approval_research_mgr_flag === "1") {
                    display = "block";
                }
            } else if (userType === LOCAL_CONSTANT.USER_TYPE.RFC) {
                if (objLocationAddSurvey.approval_mgr_flag === "1") {
                    display = "block";
                }
            }
        }

        return display;
    };

    const showTimeCreated = (data: any) => {
        let timeCreated = "";
        if ("name" in data) {
            timeCreated = dayjs(data?.timeCreated).format(
                "YYYY/MM/DD HH:mm:ss"
            );
        }

        return timeCreated;
    };

    return (
        <Box>
            {/* ユーザがリサーチのとき、「参照値算出結果」を表示 */}
            {userType === LOCAL_CONSTANT.USER_TYPE.RR &&
                props.menuLabel === LOCAL_CONSTANT.LABEL.COVER_REFERENCE && (
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography
                            sx={{
                                margin: "46px 0",
                                alignSelf: "flex-start",
                                whiteSpace: "nowrap",
                                fontWeight: "bold",
                            }}
                        >
                            参考値算出結果
                        </Typography>
                        <Box sx={{ display: "flex", margin: "0 10px" }}>
                            {labels.map((label, index) => (
                                <Box key={index}>
                                    <Typography
                                        align="center"
                                        sx={{ fontWeight: "bold" }}
                                    >
                                        {label.header}
                                    </Typography>
                                    <TextField
                                        value={
                                            addSurveyReferenceValue[label.Name]
                                        }
                                        onChange={(e) =>
                                            handleIntInputChange(e, label.Name)
                                        }
                                        onBlur={(e) =>
                                            handleInputBlur(e, label.Name)
                                        }
                                        inputProps={{
                                            sx: {
                                                width: "100px",
                                                textAlign: "center",
                                                backgroundColor: "#FFFCD6",
                                            },
                                        }}
                                    />
                                </Box>
                            ))}
                        </Box>
                        <Box>
                            <Box sx={{ display: "flex" }}>
                                <Box
                                    sx={{
                                        width: "120px",
                                        border: "1px solid #000",
                                        textAlign: "center",
                                    }}
                                >
                                    担当者
                                </Box>
                                <Box
                                    sx={{
                                        width: "120px",
                                        border: "1px solid #000",
                                        textAlign: "center",
                                    }}
                                >
                                    リサーチ Mgr
                                </Box>
                                {approvalReferenceResearchGmStamp != '' && (
                                    <Box
                                        sx={{
                                            width: "120px",
                                            border: "1px solid #000",
                                            textAlign: "center",
                                        }}
                                    >
                                        リサーチ GM
                                    </Box>
                                )}
                            </Box>
                            <Box sx={{ display: "flex" }}>
                                <Box
                                    sx={{
                                        width: "120px",
                                        height: "92px",
                                        border: "1px solid #000",
                                        textAlign: "center",
                                    }}
                                >
                                    <img
                                        src={approvalReferenceStaffStamp}
                                    ></img>
                                </Box>
                                <Box
                                    sx={{
                                        width: "120px",
                                        height: "92px",
                                        border: "1px solid #000",
                                        textAlign: "center",
                                    }}
                                >
                                    <img
                                        src={approvalReferenceResearchMgrStamp}
                                    ></img>
                                </Box>
                                {approvalReferenceResearchGmStamp != '' && (
                                    <Box
                                        sx={{
                                            width: "120px",
                                            height: "92px",
                                            border: "1px solid #000",
                                            textAlign: "center",
                                        }}
                                    >
                                        <img
                                            src={approvalReferenceResearchGmStamp}
                                        ></img>
                                    </Box>
                                )}
                            </Box>
                        </Box>
                    </Box>
                )}

            <MessageDialog
                props={{
                    open: messageDialogOpen,
                    handleModal: closeMessageDialog,
                    body: message,
                    hasButton: hasButton,
                    buttonBody: LOCAL_CONSTANT.LABEL.CLOSE,
                }}
            />
            {props.menuLabel === LOCAL_CONSTANT.LABEL.COVER_REFERENCE && (
                <input
                    id="addCoverFileElem"
                    type="file"
                    style={{ display: "none" }}
                    onChange={handleChangeFile}
                    accept=".xlsx"
                />
            )}
            {props.menuLabel === LOCAL_CONSTANT.LABEL.COVER_CONFIRMED && (
                <input
                    id="addCoverConfirmedFileElem"
                    type="file"
                    style={{ display: "none" }}
                    onChange={handleChangeFile}
                    accept=".xlsx"
                />
            )}

            {props.menuLabel === LOCAL_CONSTANT.LABEL.COVER_CONFIRMED && (
                <Box sx={{ margin: "20px 0 0 0" }}>
                    <Box sx={{ display: "flex" }}>
                        <Box
                            sx={{
                                width: "120px",
                                border: "1px solid #000",
                                textAlign: "center",
                            }}
                        >
                            リサーチ Mgr
                        </Box>
                        <Box
                            sx={{
                                width: "120px",
                                border: "1px solid #000",
                                textAlign: "center",
                            }}
                        >
                            リサーチ GM
                        </Box>
                        <Box
                            sx={{
                                width: "120px",
                                border: "1px solid #000",
                                textAlign: "center",
                            }}
                        >
                            リクルート Mgr
                        </Box>
                        <Box
                            sx={{
                                width: "120px",
                                border: "1px solid #000",
                                textAlign: "center",
                            }}
                        >
                            リクルート GM
                        </Box>
                    </Box>
                    <Box sx={{ display: "flex" }}>
                        <Box
                            sx={{
                                width: "120px",
                                height: "92px",
                                border: "1px solid #000",
                                textAlign: "center",
                            }}
                        >
                            <img src={approvalResearchMgrStamp}></img>
                        </Box>
                        <Box
                            sx={{
                                width: "120px",
                                height: "92px",
                                border: "1px solid #000",
                                textAlign: "center",
                            }}
                        >
                            <img src={approvalResearchGmStamp}></img>
                        </Box>
                        <Box
                            sx={{
                                width: "120px",
                                height: "92px",
                                border: "1px solid #000",
                                textAlign: "center",
                            }}
                        >
                            <img src={approvalMgrStamp}></img>
                        </Box>
                        <Box
                            sx={{
                                width: "120px",
                                height: "92px",
                                border: "1px solid #000",
                                textAlign: "center",
                            }}
                        >
                            <img src={approvalGmStamp}></img>
                        </Box>
                    </Box>
                </Box>
            )}
            <Box sx={{ display: "flex" }}>
                <Button
                    sx={{ margin: "20px 0" }}
                    variant="contained"
                    color="success"
                    size="small"
                    onClick={(e) => {
                        handleClickFile(props.menuLabel);
                    }}
                    disabled={hasDisabled()}
                >
                    {props.menuLabel}
                </Button>
                {/* RFCとRR場合、不備コメント 吹き出しアイコンを表示 */}
                {LOCAL_CONSTANT.USER_TYPE.RFC_RR.includes(userType) && (
                    <Grid sx={{ display: "flex", width: "100px" }}>
                        <IconButton
                            disabled={setPermissionFunc(
                                userType,
                                objLocationBase.task_id,
                                LOCAL_CONSTANT.NAVI.ADDITIONAL_RESEARCH,
                                "add_survey_cover_reference"
                            )}
                            onClick={() => {
                                handleChatBubbleClick(
                                    "add_survey_cover_reference_fixes"
                                );
                            }}
                            sx={iconHover}
                        >
                            <Box
                                sx={chatBubbleErrorSx(
                                    userType,
                                    objLocationBase.task_id,
                                    LOCAL_CONSTANT.NAVI.ADDITIONAL_RESEARCH,
                                    "add_survey_cover",
                                    listDeficiencyComment
                                )}
                            >
                                <ChatBubbleIcon sx={chatBubbleIconSx} />
                            </Box>
                        </IconButton>
                    </Grid>
                )}
                <Button
                    sx={{ margin: "20px 10px", display: displayApproved() }}
                    variant="contained"
                    color="error"
                    size="small"
                    onClick={(e) => {
                        handleCancellation(props.correctionLabel);
                    }}
                >
                    {props.correctionLabel}
                </Button>
            </Box>

            <Grid container spacing={1}>
                <Grid item xs={12} sx={{ paddingRight: "40px" }}>
                    <TableContainer
                        sx={{
                            height: "132px",
                            width: "100%",
                            border: "1px solid black",
                        }}
                    >
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={headerCell('FILE_NAME')}>
                                        {LOCAL_CONSTANT.LABEL.FILE_NAME}
                                    </TableCell>
                                    <TableCell sx={headerCell('UPLOAD_DATE')}>
                                        {LOCAL_CONSTANT.LABEL.UPLOAD_DATE}
                                    </TableCell>
                                    <TableCell sx={headerCell('UPLOADER')}>
                                        {LOCAL_CONSTANT.LABEL.UPLOADER}
                                    </TableCell>
                                    <TableCell sx={headerCell('OTHER')}></TableCell>
                                    <TableCell sx={headerCell('OTHER')}></TableCell>
                                    <TableCell sx={headerCell('OTHER')}>Excel</TableCell>
                                    <TableCell sx={headerCell('OTHER')}>PDF</TableCell>
                                    <TableCell sx={headerCell('OTHER')}></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {props.menuLabel ===
                                    LOCAL_CONSTANT.LABEL.COVER_REFERENCE &&
                                coverPdfPath?.name !== "" &&
                                objLocationAddSurvey.cover_excel_path !== "" &&
                                coverExcelPath !== undefined ? (
                                    <TableRow>
                                        <TableCell
                                            onClick={() =>
                                                handleValueChange(
                                                    coverPdfPath,
                                                    "previewPdfPath"
                                                )
                                            }
                                        >
                                            {coverPdfPath?.name}
                                        </TableCell>
                                        <TableCell
                                            onClick={() =>
                                                handleValueChange(
                                                    coverPdfPath,
                                                    "previewPdfPath"
                                                )
                                            }
                                        >
                                            {showTimeCreated(coverPdfPath)}
                                        </TableCell>
                                        <TableCell
                                            onClick={() =>
                                                handleValueChange(
                                                    coverPdfPath,
                                                    "previewPdfPath"
                                                )
                                            }
                                        >
                                            {staffName(
                                                objLocationAddSurvey?.cover_excel_user
                                            )}
                                        </TableCell>
                                        <TableCell sx={{ textAlign: "center" }}>
                                            <IconButton
                                                sx={{ color: 'black' }}
                                                onClick={() =>
                                                    handlePdfPreviewModalOpen(
                                                        "/" + coverPdfPath.fullPath
                                                    )
                                                }
                                            >
                                                <PictureAsPdfIcon />
                                            </IconButton>
                                        </TableCell>
                                        <TableCell sx={{ textAlign: "center" }}>
                                            <IconButton
                                                sx={{ color: 'black' }}
                                                onClick={() =>
                                                    handlePdfPreviewScreenOpen(
                                                        "/" + coverPdfPath.fullPath
                                                    )
                                                }
                                            >
                                                <OpenInNewIcon />
                                            </IconButton>
                                        </TableCell>
                                        <TableCell sx={{ textAlign: "center" }}>
                                            <IconButton
                                                sx={{ color: "black" }}
                                                onClick={() =>
                                                    fileDownload(coverExcelPath)
                                                }
                                            >
                                                <DownloadIcon />
                                            </IconButton>
                                        </TableCell>
                                        <TableCell sx={{ textAlign: "center" }}>
                                            <IconButton
                                                sx={{ color: "black" }}
                                                onClick={() =>
                                                    fileDownload(coverPdfPath)
                                                }
                                            >
                                                <DownloadIcon />
                                            </IconButton>
                                        </TableCell>
                                        <TableCell sx={{ textAlign: "center" }}>
                                            <IconButton
                                                disabled={hasDeleteDisabled()}
                                                sx={{ color: "black" }}
                                                onClick={() =>
                                                    handleModalOpen(
                                                        "/" +
                                                            coverExcelPath.fullPath,
                                                        "/" +
                                                            coverPdfPath.fullPath
                                                    )
                                                }
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ) : props.menuLabel ===
                                      LOCAL_CONSTANT.LABEL.COVER_CONFIRMED &&
                                  coverConfirmPdfPath?.name !== "" &&
                                  objLocationAddSurvey.cover_confirm_excel_path !==
                                      "" &&
                                  coverExcelPath !== undefined ? (
                                    <TableRow>
                                        <TableCell
                                            onClick={() =>
                                                handleValueChange(
                                                    coverConfirmPdfPath,
                                                    "previewPdfPath"
                                                )
                                            }
                                        >
                                            {coverConfirmPdfPath?.name}
                                        </TableCell>
                                        <TableCell
                                            onClick={() =>
                                                handleValueChange(
                                                    coverConfirmPdfPath,
                                                    "previewPdfPath"
                                                )
                                            }
                                        >
                                            {showTimeCreated(
                                                coverConfirmPdfPath
                                            )}
                                        </TableCell>
                                        <TableCell
                                            onClick={() =>
                                                handleValueChange(
                                                    coverConfirmPdfPath,
                                                    "previewPdfPath"
                                                )
                                            }
                                        >
                                            {staffName(
                                                objLocationAddSurvey?.cover_confirm_excel_user
                                            )}
                                        </TableCell>
                                        <TableCell sx={{ textAlign: "center" }}>
                                            <IconButton
                                                sx={{ color: 'black' }}
                                                onClick={() =>
                                                    handlePdfPreviewModalOpen(
                                                        "/" + coverConfirmPdfPath.fullPath
                                                    )
                                                }
                                            >
                                                <PictureAsPdfIcon />
                                            </IconButton>
                                        </TableCell>
                                        <TableCell sx={{ textAlign: "center" }}>
                                            <IconButton
                                                sx={{ color: 'black' }}
                                                onClick={() =>
                                                    handlePdfPreviewScreenOpen(
                                                        "/" + coverConfirmPdfPath.fullPath
                                                    )
                                                }
                                            >
                                                <OpenInNewIcon />
                                            </IconButton>
                                        </TableCell>
                                        <TableCell  sx={{ textAlign: "center" }}>
                                            <IconButton
                                                sx={{ color: "black" }}
                                                onClick={() =>
                                                    fileDownload(
                                                        coverConfirmExcelPath
                                                    )
                                                }
                                            >
                                                <DownloadIcon />
                                            </IconButton>
                                        </TableCell>
                                        <TableCell  sx={{ textAlign: "center" }}>
                                            <IconButton
                                                sx={{ color: "black" }}
                                                onClick={() =>
                                                    fileDownload(
                                                        coverConfirmPdfPath
                                                    )
                                                }
                                            >
                                                <DownloadIcon />
                                            </IconButton>
                                        </TableCell>
                                        <TableCell  sx={{ textAlign: "center" }}>
                                            <IconButton
                                                disabled={hasDeleteDisabled()}
                                                sx={{ color: "black" }}
                                                onClick={() =>
                                                    handleModalOpen(
                                                        "/" +
                                                            coverConfirmExcelPath.fullPath,
                                                        "/" +
                                                            coverConfirmPdfPath.fullPath
                                                    )
                                                }
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    <TableRow sx={{ height: "73px" }}>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>

            {/* プレビュー */}
            {props.menuLabel === LOCAL_CONSTANT.LABEL.COVER_REFERENCE &&
                previewPdfPath !== "" && (
                    <Box sx={{ padding: "30px 40px 0px 0px" }}>
                        <PdfViewer props={{ pdfPath: previewPdfPath }} />
                    </Box>
                )}
            {props.menuLabel === LOCAL_CONSTANT.LABEL.COVER_CONFIRMED &&
                previewConfirmedPdfPath !== "" && (
                    <Box sx={{ padding: "30px 40px 0px 0px" }}>
                        <PdfViewer
                            props={{ pdfPath: previewConfirmedPdfPath }}
                        />
                    </Box>
                )}

            {/* 削除確認モーダル */}
            <DeleteConfirmationModal
                modalOpen={deleteConfModalOpen}
                setModalOpen={setDeleteConfModalOpen}
                deleteMethod={handleExcelDeleteChange}
            />

            {/* 不備コメント モーダル画面 */}
            <DeficiencyCommentRegistModal
                props={{
                    userType: userType,
                    modalOpen: deficiencyComentModalFlag,
                    setModalOpen: setDeficiencyComentModalFlag,
                    CommentTextFieldObj: additionalResearchCommentTextFiledObj,
                    tableName: LOCAL_CONSTANT.TABLE.BASE,
                    columnName: labelNameStr,
                    subKey: LOCAL_CONSTANT.DEFICIENCY.DEFAULT_SUB_KEY,
                    handleCommentChange: handleCommentChange,
                    handleSaveComment: handleSaveComment,
                }}
            />

            <CancellationAddSurveyModal
                props={{
                    open: showCancellationModal,
                    handleModal: setShowCancellationModal,
                    planAreaId: objLongPageParam.planAreaId,
                    branch: objLongPageParam.branch,
                    mode: props.menuLabel,
                }}
            />

            {/* PDFプレビューモーダル */}
            <PdfViewerModal
                props={{
                    open: pdfPreviewModalFlag,
                    setOpen: setPdfPreviewModalFlag,
                    pdfPath: pdfPath,
                }}
            />
        </Box>
    );
};

export default AddCover;
